export default __webpack_public_path__ + "./font/ed4fdc884572736f49a10d2a800ca644.svg";